import {scrollToTop} from '../lib/utils';
import {Tabs} from 'foundation-sites';
import {throttle} from '../lib/throttle';

const aggregate = {

	$window: $(window),

	elem: {
		$body: $('body'),
		$results: $('.aggregate__panel.is-active .aggregate__set'),
		$resultsListings: $('.aggregate__panel.is-active .aggregate__results'),
		$form: $('.aggregate__panel.is-active .filter__form'),
		$select: $('.aggregate__panel.is-active .filter select'),
		$input: $('.aggregate__panel.is-active .filter input'),
		$keywords: $('.aggregate__panel.is-active input[type="search"]'),
		$keywordsSubmit: $('.aggregate__panel.is-active .search-button'),
		$reset: $('.reset-chips'),
		$page: $('.pagination__link, .pagination__turn'),
		$tabs: $('#aggregate-tabs')
	},

	resultsSelector: '.aggregate__panel.is-active .aggregate__set',
	listingsSelector: '.aggregate__panel.is-active .aggregate__results',

	page: 1,
	keywords: '',
	originalKeywords: '',

	// Search field name
	searchName: 'search',

	// Flag: A query is in progress
	inMotion: false,

	// Flag: App is resetting the form
	resetting: false,
	selectChange: false,

	// Flag: App is going backwards or forwards in browser history
	traveling: false,

	// Flag: Page of results is being changed
	paging: false,

	tabs: false,
	switching: false,

	init() {

		// Bind elements
		this.setElems();

		let url = this.getUrl();
		let history = url + this.plainQuery();

		this.updateHistory(history, true);

		// Bind event handlers
		this.bindUIActions();

		this.selectability();

		if (this.elem.$tabs.length > 0) {
			this.setupTabs();
		}

	},

	bindUIActions() {

		let _this = this;

		_this.elem.$input.on('change', _this.loadResults.bind(this));

		_this.elem.$select.on('change', _this.handleSelect.bind(this));

		_this.elem.$form.on('submit', _this.handleFormSubmit.bind(this));

		_this.elem.$keywords.on('keyup', _this.handleKeywordSubmit.bind(this));

		// Enter or Spacebar hit on a label (which should activate the checkbox/radio)
		$('.filter label').on('keyup', function (e) {
			let keyCode = e.keyCode;
			if (keyCode === 32 || keyCode === 13) {
				e.preventDefault();
				$(this).click();
				return false;
			}
		});

		// If the user changes the page
		_this.elem.$body.on('click', '.pagination__link, .pagination__turn', _this.changePage.bind(this));

		// If the user clicks a chip to remove a filter
		_this.elem.$body.on('click', '.chip', function (e) {

			e.preventDefault();

			let $el = $(e.currentTarget);

			let key = $el.attr('data-key');

			let $filter = $('input[id="' + key + '"], select[id="' + key + '"]');

			if ($filter.length > 0) {
				if ($filter.attr('type') === 'checkbox' || $filter.attr('type') === 'radio') {
					$filter.prop('checked', false);
				} else {
					$filter.val('');
				}
			}

			_this.loadResults();

		});

		if (this.tabs !== false) {
			_this.scrollSet(_this.elem.$tabs.parents('.aggregate__tabs').find('.aggregate__tabs-container'));
			_this.elem.$tabs.parents('.aggregate__tabs')
				.find('.aggregate__tabs-container')
				.on('scroll', throttle(this.onScroll.bind(this), 10));
		}

		// History changes (back button/forward button)
		window.onpopstate = _this.updateFilters.bind(this);

	},

	onScroll(e) {
		let $target = $(e.target);

		this.scrollSet($target);

	},

	scrollSet(el) {

		let width = el.outerWidth();
		let scrollLeft = el.scrollLeft();
		let scrollWidth = el[0].scrollWidth;

		el.parents('.aggregate__tabs').toggleClass('aggregate__tabs--has-shadow', ((Math.round(scrollWidth - width)) !== (Math.floor(scrollLeft) || Math.round(scrollLeft))));

	},

	setupTabs() {

		this.elem.$tabs.on('change.zf.tabs', this.switchTab.bind(this));

		this.tabs = new Tabs(this.elem.$tabs);

	},

	switchTab(tabEvent, activeTab) {

		let _this = this;

		if (!this.switching) {

			this.switching = true;

			this.setElems();

			let url = _this.getUrl();
			let history = url + this.plainQuery();

			this.updateHistory(history, false);

			this.scrollToTab(activeTab);

			setTimeout(function () {
				_this.switching = false;
			}, 400);

		}

	},

	scrollToTab(el) {

		let container = el.parents('.aggregate__tabs-container');

		let containerScrollLeft = container.scrollLeft();
		let tabScrollOffset = el.offset();
		let padd = 64;

		let theOffset = (tabScrollOffset.left + containerScrollLeft) - padd;

		container.animate({
			scrollLeft: theOffset
		}, 250);

	},

	setElems() {

		let _this = this;

		_this.elem.$results = $('.aggregate__panel.is-active .aggregate__set');
		_this.elem.$resultsListings = $('.aggregate__panel.is-active .aggregate__results');
		_this.elem.$form = $('.aggregate__panel.is-active .filter__form');
		_this.elem.$select = $('.aggregate__panel.is-active .filter select');
		_this.elem.$input = $('.aggregate__panel.is-active .filter input');
		_this.elem.$keywords = $('.aggregate__panel.is-active input[type="search"]');
		_this.elem.$keywordsSubmit = $('.aggregate__panel.is-active .search-button');

		_this.bindUIActions();

	},

	handleKeywordSubmit: function (e) {

		// Handles Enter key press on keywords field.
		let _this = this;
		if (e.keyCode === 13) {
			e.preventDefault();
			_this.loadResults();
		}

	},

	handleFormSubmit: function (e) {
		let _this = this;

		e.preventDefault();
		_this.loadResults();
	},

	handleSelect: function () {

		let _this = this;
		_this.loadResults();

	},

	serializeFilter: function () {

		let _this = this;

		let s = _this.serialToObject();

		let c = _this.cleanObject(s);

		return c;

	},

	serializeForm: function () {

		let _this = this;

		let formData = _this.elem.$form.serialize();

		let serialForm = _this.serialToObject(formData);

		let cleaned = _this.cleanObject(serialForm);

		return _this.objectToSerial(cleaned);

	},

	serialToObject: function (serial) {

		let
			i = 0,
			retObj = {},
			pair = null;

		if (typeof serial === 'undefined') {
			serial = window.location.search.substring(1);
		}

		if (serial !== '') {

			let sPageURL = serial,
				qArr = sPageURL.split('&');

			for (; i < qArr.length; i += 1) {
				pair = qArr[i].split('=');
				if (!retObj.hasOwnProperty(decodeURIComponent(pair[0]))) {
					retObj[decodeURIComponent(pair[0])] = [];
				}

				retObj[decodeURIComponent(pair[0])].push(pair[1]);
			}

		}

		return retObj;

	},

	objectToSerial: function (obj) {

		let queryString = Object.keys(obj).map(function (key) {
			return key + '=' + obj[key];
		}).join('&');

		return queryString;

	},

	// Remove empty values and fields
	cleanObject: function (obj) {

		let propNames = Object.getOwnPropertyNames(obj);
		for (let i = 0; i < propNames.length; i += 1) {
			let propName = propNames[i];
			if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
				delete obj[propName];
			}
		}

		// Search exclusion
		if (obj[this.searchName] && obj[this.searchName][0] === '') {
			delete obj[this.searchName];
		}

		return obj;

	},

	updateFilters: function () {
		let _this = this;

		_this.traveling = true;

		let filters = _this.serializeFilter();

		_this.resetFilters();

		for (let f in filters) {
			if (filters.hasOwnProperty(f)) {

				let el = $('input[name="' + f + '"]');

				if (el.attr('type') === 'checkbox' || el.attr('type') === 'radio') {
					el = $('input[name="' + f + '"][value="' + filters[f] + '"]');

					el.prop('checked', true);
				} else {
					el.val(filters[f]);
				}

			}
		}

		setTimeout(function () {
			_this.loadResults();
		}, 400);

	},

	resetFilters: function (e) {

		let _this = this;

		_this.resetting = true;

		if (typeof e !== 'undefined') {
			e.preventDefault();
		}

		_this.page = 1;
		_this.elem.$form.find('js-filter-page').val(1);
		_this.keywords = '';

		_this.elem.$keywords.val(_this.keywords);

		_this.elem.$form[0].reset();

		_this.elem.$select.trigger('change');

		setTimeout(function () {
			_this.resetting = false;
		}, 400);

	},

	resetAndLoad: function (e) {

		let _this = this;

		if (typeof e !== 'undefined') {
			e.preventDefault();
		}

		_this.elem.$results.addClass('js-is-loading');

		_this.resetFilters();

		setTimeout(function () {
			_this.loadResults();
		}, 400);

	},

	changePage: function (event) {

		event.preventDefault();

		let _this = this;

		let $el = $(event.currentTarget);
		let page = $el.attr('data-page');

		_this.paging = true;
		_this.page = page;

		_this.elem.$form.find('.js-filter-page').val(page);

		_this.loadQuery();

		scrollToTop(_this.elem.$results);

	},

	dataQuery: function () {
		let _this = this;
		let query = _this.plainQuery();

		if (query !== '') {
			query += '&data=1';
		} else {
			query = '?data=1';
		}

		return query;
	},

	plainQuery: function () {

		let _this = this;
		let query = '';

		let formResults = _this.serializeForm();
		if (formResults !== '') {
			query += formResults;
		}

		query = '?' + query;

		if (query === '?page=1') {
			query = '';
		}

		return query;

	},

	loadResults: function () {

		let _this = this;

		if (!_this.resetting) {
			_this.loadQuery();
		}

	},

	getUrl: function () {

		let loc = window.location;

		return loc.protocol + '//' + loc.host + loc.pathname;

	},

	updateHistory: function (history, replace) {

		let _this = this;

		let historyReplace = false;

		if (typeof replace !== 'undefined') {
			if (replace !== true) {
				historyReplace = false;
			} else {
				historyReplace = true;
			}
		}

		if (!_this.traveling) {
			if (historyReplace) {
				window.history.replaceState({path: history}, '', history);
			} else {
				window.history.pushState({path: history}, '', history);
			}
		} else {
			_this.traveling = false;
		}

		_this.serializeFilter();

	},

	loadQuery: function (query) {

		let _this = this;

		if (!_this.inMotion) {

			_this.inMotion = true;

			let url = _this.getUrl();

			if (typeof query === 'undefined') {
				if (!_this.paging && !_this.traveling) {
					_this.page = 1;
					_this.elem.$form.find('.js-filter-page').val(1);
				}

				query = this.dataQuery();
			}

			let history = url + this.plainQuery();

			_this.elem.$results.addClass('js-is-loading');

			$.ajax({
				url: url + query
			}).done(function (data) {

				_this.updateHistory(history);

				let html = $.parseHTML(data, window.document, false);

				let $results = $(html).find(_this.resultsSelector).html();

				if ($(html).is(_this.resultsSelector)) {
					$results = html;
				}

				if ($results.indexOf('<p>This search criteria did not return any results.</p>') >= 0) {
					console.log('This page did not return results.');
				}

				_this.elem.$results.html($results);

				_this.elem.$results.removeClass('js-is-loading');

			}).fail(function () {

				_this.errorState();

			}).always(function () {

				_this.paging = false;
				_this.inMotion = false;

			});

		}

	},

	errorState: function () {

		console.error('Error has occurred in aggregate.js');

		this.elem.$results.html('<p>An error has occurred. Please contact an administrator.</p>');

	},

	selectability() {
		let _this = this;

		if (_this.elem.$select.length > 0) {
			_this.elem.$select.selectability({
				'position': 'above',
				'floatLabel': 'true'
			});

			$('.selectability[aria-disabled="true"]').attr('tabindex', '-1');

			_this.elem.$select = $('.aggregate__panel.is-active .filter select');
		}
	}

};

export {aggregate};
